import React from 'react';


class Databasepython extends React.Component{
    render(){
        return (
            <React.Fragment>
              <div className="Page">
                 <div className="OneApp">
                        <h5>GameOverWeb data base</h5>
                        
                        
                        <img src="https://raw.githubusercontent.com/BrandonGrimaldoM/GameOverWebDataBase/master/BD/ERM.PNG" width="700" height="560" align="center" alt="py"/>
                        
                        
                        
                        
                        <p align="left">Esta base de datos en MySql pertenece a la aplicación gameoverweb hecha con ayuda del ORM de Django.</p>
                        
                        <p align="left">Puedes ver el repositorio dando click <a href="https://github.com/BrandonGrimaldoM/GameOverWebDataBase" target="_blank" rel='noreferrer'>AQUI.</a></p>
                        
                        <div className="space"></div>
                        
                        
                 </div>
                 
                
             </div>
          
            </React.Fragment>
        ); 
    }
}

export default Databasepython;